interface Args {
  fromColor: string;
  toColor: string;
}
export function gradientCss({ fromColor, toColor }: Args) {
  return `transparent linear-gradient(146deg, ${fromColor} 0%, ${toColor} 100%) 0% 0% no-repeat padding-box`;
}
